// Runtime configuration, distinct from Vite's build-time env vars.
//
// import.meta.env.VITE_* is baked into the JS bundle at build time. That is
// fine for local dev, but it means a container image built once could not be
// deployed to dev/staging/production with different backend URLs without a
// separate build per environment. The Docker entrypoint instead writes a
// small env-config.js — loaded before the app bundle — that sets these
// globals from real container environment variables at startup, so one image
// is deployable everywhere. This file is the single place that resolves
// "runtime value, falling back to the build-time one" for each setting.
declare global {
  interface Window {
    __ENV?: {
      API_BASE_URL?: string;
      MAX_CONCURRENT_STREAMS?: string;
      AUTO_START_STREAMS?: string;
    };
  }
}

export function getApiBaseUrl(): string {
  return window.__ENV?.API_BASE_URL || import.meta.env.VITE_API_BASE_URL || "http://localhost:8080";
}

export function getMaxConcurrentStreamsConfig(): string | undefined {
  return window.__ENV?.MAX_CONCURRENT_STREAMS || import.meta.env.VITE_MAX_CONCURRENT_STREAMS;
}

export function getAutoStartStreamsConfig(): string | undefined {
  return window.__ENV?.AUTO_START_STREAMS || import.meta.env.VITE_AUTO_START_STREAMS;
}
